var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bewerb)?_c('div',{staticClass:"title my-1",staticStyle:{"line-height":"1.2"}},[_c('div',[_vm._v(_vm._s(_vm.meisterschaftName)+" "+_vm._s(_vm.bewerb.settings.sportJahr.replace('_', '/')))]),_c('div',[_vm._v(_vm._s(_vm.bewerb.settings.meisterschaftName)+", "+_vm._s(_vm.bewerbName)+" "),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }